export default __webpack_public_path__ + "static/media/payment-qr.a4ec5ccb.png";